// Version 3: Texte des Anfragewegs (Seite /kontakt, Rückruf, Anfrageblock, schwebender Hinweis, Button in der Navigation).
// Deutsch zuerst, Englisch vorerst Platzhalter in eckigen Klammern. Ohne Gedankenstriche und ohne Bindestriche als Satzzeichen.
// Platzhalter im Text: {name} = Dateiname, {n} = Anzahl.
const P = (s) => `[Placeholder: ${s}]`;

const de = {
    hero: {
        title: "Anfrage stellen",
        lead: "Ein Ansprechpartner für Ihre industriellen Bestände. Wenige Angaben genügen: Schicken Sie uns Ihre Bestandsliste oder ein paar Fotos, wir melden uns mit einer ersten Einschätzung.",
        waysLabel: "So erreichen Sie uns",
        quickLead: "Lieber direkt sprechen?",
        quickBooking: "Termin vereinbaren",
    },
    ways: {
        inquiry: { title: "Anfrage mit Dateien", text: "Bestandsliste oder Fotos hochladen, in drei kurzen Schritten." },
        callback: { title: "Rückruf vereinbaren", text: "Sie nennen uns eine Zeit, wir rufen Sie an." },
        booking: { title: "Termin vereinbaren", text: "Ein Gespräch zu einem festen Zeitpunkt.", textFallback: "Wir stimmen den Termin bei einem kurzen Rückruf ab." },
        phone: { title: "Anrufen", text: "Direkt mit unserem Team sprechen." },
        mail: { title: "E-Mail schreiben", text: "Gern auch mit Bestandsliste im Anhang." },
        whatsapp: { title: "WhatsApp", text: "[Platzhalter: WhatsApp folgt]" },
    },
    modes: {
        label: "Art der Anfrage",
        inquiry: "Anfrage mit Dateien",
        callback: "Rückruf vereinbaren",
    },
    // Wege im eingebetteten Formular (way sale, buy, advice). Dienstleistung statt Verkauf, kein Sofort Versprechen.
    // wayLines und buyTopic gehen als Text an das Team (Nachricht und Betreff), buyTopic hält die interne Weiterleitung erkennbar.
    formWays: {
        wayLabel: "Wie sollen wir vorgehen?",
        ways: [
            { id: "sale", title: "Bestmöglich verwerten lassen", desc: "Parto bringt Ihren Bestand an den Markt und findet die passenden Abnehmer." },
            { id: "buy", title: "Ankauf anfragen", desc: "Sie bieten Ihren Bestand an, wir prüfen einen Ankauf." },
            { id: "advice", title: "Erst beraten lassen", desc: "Wir empfehlen Ihnen den passenden Weg." },
        ],
        wayLines: { sale: "Bestmöglich verwerten lassen", buy: "Ankauf anfragen", advice: "Erst beraten lassen" },
        buyTopic: "Ankauf angefragt (BuyParto)",
        successBuy: "Ihr Angebot zum Ankauf liegt uns vor.",
    },
    // Seite /kontakt im Aufbau der Landingpages (Hero zweispaltig mit Karte rechts, darunter „So geht es weiter“)
    page: {
        h1: "Kontakt zu Parto",
        lead: "Ein Ansprechpartner für Ihre industriellen Bestände, vom ersten Gespräch bis zur Abrechnung. Schreiben Sie uns oder lassen Sie sich zurückrufen.",
        waysLabel: "Direkte Wege",
        phone: "Telefon",
        mail: "E-Mail",
        booking: "Termin vereinbaren",
        bookingHint: "per Rückruf abstimmen",
        whatsapp: "WhatsApp",
        whatsappPh: "[Platzhalter]",
        location: "Standort",
        route: "Route planen",
        trustLine: "Industrieunternehmen, die mit Parto arbeiten",
        logo: "[Logo]",
        tabsLabel: "Art der Anfrage",
        tabInquiry: "Anfrage",
        tabCallback: "Rückruf",
        stepsTitle: "So geht es weiter",
        steps: [
            { t: "Sie melden sich", d: "Mit Anfrage, Bestandsliste und Fotos oder einer Wunschzeit für den Rückruf." },
            { t: "Parto prüft und bewertet", d: "Wir sehen uns Ihre Angaben an und melden uns mit einer ersten Einschätzung." },
            { t: "Gemeinsam festlegen", d: "Sie entscheiden über das Vorgehen. Parto übernimmt Abwicklung, Marktzugang und Abrechnung." },
        ],
    },
    // Kompaktformular (QuickInquiry) für Landingpages und Produkte Seiten
    quick: {
        titleAssets: "Bestand anbieten",
        titleGeneral: "Anfrage senden",
        text: "Liste oder Fotos genügen. Wir melden uns mit einer ersten Einschätzung.",
        sectionTitle: "Bestand anbieten, ohne Aufwand für Sie",
        sectionText: "Schicken Sie uns Ihre Bestandsliste oder ein paar Fotos. Parto prüft die Unterlagen, bewertet den Bestand und meldet sich mit einem Vorschlag für das weitere Vorgehen.",
        sectionPoints: ["Rückmeldung von einer festen Person", "Erste Einschätzung auf Basis Ihrer Unterlagen", "Unverbindlich und vertraulich"],
        firstName: "Vorname",
        lastName: "Nachname",
        company: "Firma",
        email: "E-Mail",
        phone: "Telefon",
        message: "Nachricht",
        optional: "optional",
        messagePh: "Um welche Bestände geht es? Menge, Hersteller, Zustand oder Standort helfen uns weiter.",
        files: "Bestandsliste oder Fotos",
        addMessage: "Nachricht hinzufügen",
        hintShort: "Excel, CSV, PDF, Word oder Fotos · bis 10 MB je Datei · höchstens 5 Dateien",
        // Im Hero kürzer, damit der Hinweis einzeilig bleibt und der Button bei 1280 × 720 sichtbar ist (CSV wird weiter angenommen)
        hintHero: "Excel, CSV, PDF, Word oder Fotos · bis 10 MB · max. 5 Dateien",
        consentPrefix: "Ich stimme der Verarbeitung meiner Angaben gemäß der ",
        consentLink: "Datenschutzerklärung",
        consentSuffix: " zu.",
        drop: "Dateien hierher ziehen oder",
        choose: "auswählen",
        dropActive: "Dateien loslassen",
        submitAssets: "Bestand anbieten",
        submitProject: "Projekt anfragen",
        submitSurplus: "Überbestand anbieten",
        submitCareer: "Bewerbung senden",
        submitBuy: "Ankauf anfragen",
        submitMachine: "Maschinen anbieten",
        submitGeneral: "Anfrage senden",
        sending: "Wird gesendet",
        required: "Bitte füllen Sie die Pflichtfelder aus, prüfen Sie Ihre Angabe im Feld E-Mail und bestätigen Sie den Datenschutz.",
        error: "Das hat leider nicht geklappt. Bitte versuchen Sie es noch einmal oder rufen Sie uns an:",
        phoneLead: "Lieber direkt sprechen?",
        fieldRequired: "Bitte ausfüllen.",
        fieldEmail: "Bitte prüfen Sie Ihre Angabe im Feld E-Mail.",
        consentMissing: "Bitte bestätigen Sie den Datenschutz.",
        errorTooLarge: "Die Dateien sind zusammen zu groß. Bitte senden Sie höchstens 50 MB oder schicken Sie größere Dateien per E-Mail.",
        successTitle: "Danke, Ihre Anfrage ist eingegangen.",
        successText: "Wir prüfen Ihre Angaben und melden uns mit einer ersten Einschätzung.",
        reference: "Referenz",
        restart: "Weitere Anfrage senden",
        // An das Team (Betreff und Nachricht), bewusst auf Deutsch
        topicBase: "Bestandsanfrage",
        topicGeneral: "Anfrage über Kompaktformular",
        topicPartner: "Anfrage Partnernetzwerk",
        topicCareer: "Bewerbung",
        topicCareerOpen: "Initiativbewerbung",
        msgJob: "Stelle",
        msgJobOpen: "Initiativbewerbung",
        careerFor: "Ihre Bewerbung für: {job}",
        careerOpen: "Ihre Initiativbewerbung",
        filesCareer: "Lebenslauf und Unterlagen",
        companyCareerFallback: "Bewerbung (privat)",
        msgChoice: "Anliegen",
        // Auswahl „Worum geht es?“ (nur /kontakt), ohne Auswahl gilt die Vorbelegung der Adresse
        choice: {
            label: "Anliegen",
            placeholder: "Bitte wählen",
            options: [
                { id: "bestand", label: "Bestand anbieten" },
                { id: "maschinen", label: "Maschinen anbieten" },
                { id: "ankauf", label: "Ankauf anfragen" },
                { id: "beratung", label: "Erst beraten lassen" },
                { id: "partner", label: "Partner werden" },
                { id: "bewerbung", label: "Bewerbung" },
                { id: "sonstiges", label: "Sonstiges" },
            ],
        },
        // Produktkategorien (Mehrfachauswahl im Kompaktformular)
        categories: {
            label: "Kategorien",
            placeholder: "Kategorien wählen",
            one: "{label}",
            many: "{n} Kategorien gewählt",
        },
        filesTaken: "{n} Dateien übernommen",
        fileTakenOne: "1 Datei übernommen",
        // Betreff je Seite, wenn die Vorbelegung keine Ausgangslage enthält
        topicByPath: { "/maschinen-anlagen-verkaufen": "Maschinen und Anlagen", "/bestaende-verkaufen": "Industrielle Bestände" },
        msgSource: "Quelle: Kompaktformular",
        msgPage: "Seite",
        msgSituation: "Ausgangslage",
        msgCategories: "Kategorien",
        msgPhone: "Telefon",
        msgNoMessage: "(keine Nachricht)",
        msgNoPhone: "(keine Angabe)",
    },
    // Übrige Texte im eingebetteten Formular (überschreiben die Texte aus Version 2 nur in Version 3).
    // Dienstleistungssprache, kein Sofort Versprechen, Recycling nur als ordnungsgemäßes Recycling oder Rohstoffrückgewinnung.
    formCopy: {
        intents: [
            { id: "assets", name: "Bestände", title: "Wir haben Bestände, Maschinen oder einen Standort.", desc: "Überbestände, Altbestände, Ersatzteile, Maschinen, Anlagen oder ein ganzer Standort.", cta: "Bestand anbieten" },
            { id: "operations", name: "Abwicklung", title: "Wir brauchen Unterstützung bei Abwicklung und Logistik.", desc: "Erfassen, lagern, verpacken, versenden. Parto übernimmt die operative Arbeit rund um Ihre Bestände.", cta: "Abwicklung anfragen" },
            { id: "partnership", name: "Partnernetzwerk", title: "Wir möchten Teil des Partnernetzwerks werden.", desc: "Als Abnehmer, Händler, Logistiker oder Fachbetrieb für Rohstoffrückgewinnung.", cta: "Partner werden" },
            { id: "general", name: "Allgemein", title: "Wir haben eine andere Frage.", desc: "Presse, Lieferanten oder ein anderes Anliegen.", cta: "Nachricht senden" },
        ],
        situations: [
            { id: "surplus", label: "Überbestände" },
            { id: "obsolete", label: "Altbestände und Langsamdreher" },
            { id: "mro", label: "Ersatzteile und Instandhaltung" },
            { id: "closure", label: "Werksschließung oder Restrukturierung" },
            { id: "transfer", label: "Produktion zieht um" },
            { id: "other", label: "Etwas anderes" },
        ],
        releasedLabel: "Ist intern schon entschieden, dass der Bestand abgegeben wird?",
        timelineOptions: ["So bald wie möglich", "Innerhalb von 4 Wochen", "Innerhalb von 3 Monaten", "Planungsphase", "Noch nicht klar"],
        messagePhAssets: "Um welche Bestände geht es, was hat sich verändert und welches Ziel verfolgen Sie?",
        submitOps: "Anfrage zur Abwicklung absenden",
        partnerLabel: "Partnernetzwerk",
        partnerTitle: "Wie möchten Sie mit uns zusammenarbeiten?",
        partnerCards: [
            { id: "sales", name: "Handel und Distribution", tagline: "Sie handeln mit Industriekomponenten und suchen weitere Bezugsquellen." },
            { id: "buyer", name: "Abnehmer und Einkauf", tagline: "Sie suchen gebrauchte oder überschüssige Komponenten und Maschinen." },
            { id: "logistics", name: "Logistik", tagline: "Sie transportieren, lagern oder verpacken." },
            { id: "recovery", name: "Rohstoffrückgewinnung", tagline: "Sie sorgen für ordnungsgemäßes Recycling mit Nachweis." },
        ],
        fields: { phonePh: "+49 …", website: "Website", websitePh: "https://… (optional)" },
        funnel: { stepPartner: "Partnernetzwerk" },
    },
    filesTaken: "{n} Dateien aus dem vorherigen Schritt sind bereits angehängt.",
    fileTaken: "1 Datei aus dem vorherigen Schritt ist bereits angehängt.",
    callback: {
        title: "Wir rufen Sie an.",
        textShort: "Nennen Sie uns Nummer und Wunschzeit, wir melden uns.",
        text: "Nennen Sie uns Ihre Nummer und eine passende Zeit. Im Gespräch klären wir die wichtigsten Fragen zu Ihrem Bestand.",
        note: "Unterlagen können Sie uns auch nach dem Gespräch schicken.",
        company: "Firma",
        companyPh: "Name Ihres Unternehmens",
        name: "Name",
        namePh: "Ihr vollständiger Name",
        email: "E-Mail",
        emailPh: "name@firma.de",
        phone: "Telefon",
        phonePh: "+49 …",
        slot: "Wunschzeit",
        optional: "optional",
        slotPh: "Bitte wählen",
        slots: [
            { id: "morning", label: "Vormittag" },
            { id: "afternoon", label: "Nachmittag" },
            { id: "any", label: "Flexibel" },
        ],
        submit: "Rückruf anfordern",
        sending: "Wird gesendet",
        topic: "Rückrufwunsch",
        msgIntro: "Bitte um Rückruf",
        msgPhone: "Telefon",
        msgSlot: "Wunschzeit",
        msgNoSlot: "keine Angabe",
        successLabel: "Rückruf",
        successTitle: "Danke, wir rufen Sie an.",
        successText: "Wir melden uns bei Ihnen, nach Möglichkeit zur gewünschten Zeit.",
        successRestart: "Weiteren Rückruf anfordern",
        error: "Das hat leider nicht geklappt. Bitte versuchen Sie es noch einmal oder rufen Sie uns direkt an:",
        required: "Bitte füllen Sie die Pflichtfelder aus, prüfen Sie Ihre Angabe im Feld E-Mail und bestätigen Sie den Datenschutz.",
    },
    direct: {
        title: "Lieber direkt?",
        text: "Rufen Sie an, schreiben Sie uns oder vereinbaren Sie einen Termin. Bestandslisten und Fotos können Sie auch per E-Mail schicken.",
        phoneLabel: "Telefon",
        mailLabel: "E-Mail",
    },
    block: {
        title: "Bestandsliste oder Fotos hier ablegen und anfragen",
        text: "Legen Sie Ihre Dateien ab und senden Sie die Anfrage im nächsten Schritt. Ohne Dateien geht es genauso.",
        drop: "Dateien hierher ziehen",
        dropOr: "oder",
        choose: "Dateien auswählen",
        dropActive: "Dateien loslassen",
        hint: "Excel, CSV, PDF, Word oder Fotos · bis 10 MB je Datei · höchstens 5 Dateien",
        errType: "{name}: Dieses Dateiformat können wir leider nicht annehmen.",
        errSize: "{name} ist größer als 10 MB.",
        errCount: "Es passen höchstens 5 Dateien in eine Anfrage. {name} wurde nicht übernommen.",
        errEmpty: "{name} ist leer und wurde nicht übernommen.",
        errDuplicate: "{name} ist bereits angehängt.",
        errTotal: "Zusammen dürfen die Dateien höchstens 50 MB groß sein. {name} wurde nicht übernommen.",
        remove: "Datei entfernen",
        ready: "{n} Dateien bereit",
        readyOne: "1 Datei bereit",
        cta: "Weiter zur Anfrage",
        phoneLead: "Lieber direkt sprechen?",
    },
    stoerer: { cta: "Anfrage senden", close: "Hinweis schließen" },
    nav: { cta: "Anfrage senden" },
};

const en = {
    hero: { title: P("Send an inquiry"), lead: P("A few details are enough. Send us your inventory list or a few photos."), waysLabel: P("How to reach us"), quickLead: P("Prefer to talk?"), quickBooking: P("Book a meeting") },
    ways: {
        inquiry: { title: P("Inquiry with files"), text: P("Send your inventory list or photos in three short steps.") },
        callback: { title: P("Request a call back"), text: P("Tell us a time, we will call you.") },
        booking: { title: P("Book a meeting"), text: P("A call at a fixed time."), textFallback: P("We arrange the meeting during a short call back.") },
        phone: { title: P("Call us"), text: P("Monday to Friday during business hours.") },
        mail: { title: P("Write an email"), text: P("Feel free to attach your inventory list.") },
        whatsapp: { title: "WhatsApp", text: "[Placeholder: WhatsApp will follow]" },
    },
    modes: { label: P("Type of inquiry"), inquiry: P("Inquiry with files"), callback: P("Request a call back") },
    formWays: {
        wayLabel: P("How should we proceed?"),
        ways: [
            { id: "sale", title: P("Get the best use"), desc: P("Parto brings your inventory to market and finds suitable buyers.") },
            { id: "buy", title: P("Request a purchase"), desc: P("Offer your inventory, we review a purchase.") },
            { id: "advice", title: P("Get advice first"), desc: P("We recommend the right way.") },
        ],
        // Text an das deutsche Team, bewusst auf Deutsch
        wayLines: { sale: "Bestmöglich verwerten lassen", buy: "Ankauf anfragen", advice: "Erst beraten lassen" },
        buyTopic: "Ankauf angefragt (BuyParto)",
        successBuy: P("We will review a purchase of your inventory."),
    },
    page: {
        h1: P("Contact Parto"), lead: P("One contact for your industrial inventory."), waysLabel: P("Direct contact"),
        phone: P("Phone"), mail: P("Email"), booking: P("Book a meeting"), bookingHint: P("arranged by call back"), whatsapp: "WhatsApp", whatsappPh: "[Placeholder]",
        location: P("Location"), route: P("Get directions"), trustLine: P("Trusted by industrial companies"), logo: "[Logo]",
        tabsLabel: P("Type of inquiry"), tabInquiry: P("Inquiry"), tabCallback: P("Call back"), stepsTitle: P("What happens next"),
        steps: [{ t: P("You get in touch"), d: P("Placeholder") }, { t: P("Parto reviews"), d: P("Placeholder") }, { t: P("Decide together"), d: P("Placeholder") }],
    },
    quick: {
        titleAssets: P("Offer inventory"), titleGeneral: P("Send inquiry"),
        text: P("A list or photos are enough. We get back to you with a first assessment."),
        sectionTitle: P("Offer your inventory without effort."), sectionText: P("Send us your inventory list or a few photos."),
        sectionPoints: [P("One contact for the whole process"), P("First assessment based on your documents"), P("Non binding and confidential")],
        addMessage: P("Add message"), hintShort: P("Excel, PDF, Word, photos · up to 10 MB · max. 5 files"), hintHero: P("Excel, PDF, Word, photos · up to 10 MB · max. 5 files"),
        consentPrefix: P("I agree to the processing of my data according to the "), consentLink: P("privacy policy"), consentSuffix: ".",
        firstName: P("First name"), lastName: P("Last name"), company: P("Company"), email: P("Email"), phone: P("Phone"), message: P("Message"), optional: P("optional"),
        messagePh: P("Which inventory is it about?"),
        files: P("Inventory list or photos"), drop: P("Drag files here or"), choose: P("choose"), dropActive: P("Release files"),
        submitAssets: P("Offer inventory"), submitProject: P("Request a project"), submitSurplus: P("Offer surplus stock"), submitBuy: P("Request a purchase"), submitCareer: P("Send application"), submitMachine: P("Offer machinery"), submitGeneral: P("Send inquiry"), sending: P("Sending"),
        required: P("Please fill in the required fields and accept the privacy notice."),
        error: P("That did not work. Please try again or call us:"),
        phoneLead: P("Prefer to talk?"),
        fieldRequired: P("Please fill in."), fieldEmail: P("Please enter a valid email address."), consentMissing: P("Please accept the privacy notice."), errorTooLarge: P("Files are too large in total (max. 50 MB)."),
        successTitle: P("Thank you, your inquiry has been received."), successText: P("We will get back to you with a first assessment."),
        reference: P("Reference"), restart: P("Send another inquiry"),
        topicBase: "Bestandsanfrage", topicGeneral: "Anfrage über Kompaktformular", topicPartner: "Anfrage Partnernetzwerk", topicCareer: "Bewerbung", topicCareerOpen: "Initiativbewerbung", msgJob: "Stelle", msgJobOpen: "Initiativbewerbung",
        careerFor: P("Your application for: {job}"), careerOpen: P("Your open application"), filesCareer: P("CV and documents"), companyCareerFallback: "Bewerbung (privat)", msgChoice: "Anliegen",
        choice: { label: P("Topic"), placeholder: P("Please choose"), options: [{ id: "bestand", label: P("Offer inventory") }, { id: "maschinen", label: P("Offer machinery or equipment") }, { id: "ankauf", label: P("Request a purchase") }, { id: "beratung", label: P("Get advice first") }, { id: "partner", label: P("Become a partner") }, { id: "bewerbung", label: P("Application") }, { id: "sonstiges", label: P("Other") }] },
        categories: { label: P("Categories"), placeholder: P("Choose categories"), one: "{label}", many: P("{n} categories selected") },
        filesTaken: P("{n} files added"), fileTakenOne: P("1 file added"), msgSource: "Quelle: Kompaktformular", msgPage: "Seite", msgSituation: "Ausgangslage", msgCategories: "Kategorien", msgPhone: "Telefon", msgNoMessage: "(keine Nachricht)", msgNoPhone: "(keine Angabe)",
    },
    formCopy: {
        intents: [
            { id: "assets", name: P("Inventory"), title: P("We have inventory, machines or a site."), desc: P("Surplus, obsolete stock, spare parts, machinery, equipment or a whole site."), cta: P("Offer inventory") },
            { id: "operations", name: P("Operations"), title: P("We need support with handling and logistics."), desc: P("Recording, storage, packing, shipping. Parto takes over the operational work."), cta: P("Request operations support") },
            { id: "partnership", name: P("Partner network"), title: P("We want to join the partner network."), desc: P("As buyer, trader, logistics provider or raw material recycler."), cta: P("Become a partner") },
            { id: "general", name: P("General"), title: P("We have another question."), desc: P("Press, suppliers or another topic."), cta: P("Send message") },
        ],
        situations: [
            { id: "surplus", label: P("Surplus") },
            { id: "obsolete", label: P("Obsolete and slow moving") },
            { id: "mro", label: P("Spare parts and MRO") },
            { id: "closure", label: P("Plant closure or restructuring") },
            { id: "transfer", label: P("Production relocation") },
            { id: "other", label: P("Something else") },
        ],
        releasedLabel: P("Has it been decided internally to hand over the inventory?"),
        timelineOptions: [P("As soon as possible"), P("Within 4 weeks"), P("Within 3 months"), P("Planning phase"), P("Not clear yet")],
        messagePhAssets: P("Which inventory is it about and what is your goal?"),
        submitOps: P("Send operations request"),
        partnerLabel: P("Partner network"),
        partnerTitle: P("How would you like to work with us?"),
        partnerCards: [
            { id: "sales", name: P("Trade and distribution"), tagline: P("You trade industrial components and look for more sources.") },
            { id: "buyer", name: P("Buyers and purchasing"), tagline: P("You look for used or surplus components and machines.") },
            { id: "logistics", name: P("Logistics"), tagline: P("You transport, store or pack.") },
            { id: "recovery", name: P("Raw material recycling"), tagline: P("You provide proper recycling with documentation.") },
        ],
        fields: { phonePh: "+49 …" },
        funnel: { stepPartner: P("Partner network") },
    },
    filesTaken: P("{n} files from the previous step are already attached."),
    fileTaken: P("1 file from the previous step is already attached."),
    callback: {
        title: P("We will call you."),
        textShort: P("Leave your number and a preferred time."),
        text: P("Leave your number and a suitable time."),
        note: P("You can send documents after the call as well."),
        company: P("Company"), companyPh: P("Your company"),
        name: P("Name"), namePh: P("First and last name"),
        email: P("Email"), emailPh: "name@company.com",
        phone: P("Phone"), phonePh: "+49 …",
        slot: P("Preferred time"), optional: P("optional"), slotPh: P("Please choose"),
        slots: [
            { id: "morning", label: P("Morning") },
            { id: "afternoon", label: P("Afternoon") },
            { id: "any", label: P("Flexible") },
        ],
        submit: P("Request call back"), sending: P("Sending"),
        // Betreff und Nachricht gehen an das deutsche Team, deshalb bewusst auf Deutsch
        topic: "Rückrufwunsch", msgIntro: "Bitte um Rückruf", msgPhone: "Telefon", msgSlot: "Wunschzeit", msgNoSlot: "keine Angabe",
        successLabel: P("Call back"), successTitle: P("Thank you, we will call you."), successText: P("We will get back to you, at your preferred time where possible."),
        successRestart: P("Request another call back"),
        error: P("That did not work. Please try again or call us directly:"),
        required: P("Please fill in the required fields and accept the privacy notice."),
    },
    direct: { title: P("Prefer direct contact?"), text: P("Call us or write to us."), phoneLabel: P("Phone"), mailLabel: P("Email") },
    block: {
        title: P("Inventory list or photos? Drop them here."),
        text: P("Drop your files and send the inquiry in the next step. It works without files too."),
        drop: P("Drag files here"), dropOr: P("or"), choose: P("Choose files"), dropActive: P("Release files"),
        hint: P("Excel, CSV, PDF, Word, JPG or PNG. Up to 10 MB each, max. 5 files."),
        errType: P("{name}: this file type is not supported."),
        errSize: P("{name} is larger than 10 MB."),
        errCount: P("Max. 5 files per inquiry. {name} was not added."),
        errEmpty: P("{name} is empty."), errDuplicate: P("{name} is already attached."), errTotal: P("Files may not exceed 50 MB in total. {name} was not added."),
        remove: P("Remove file"), ready: P("{n} files ready"), readyOne: P("1 file ready"),
        cta: P("Continue to inquiry"), phoneLead: P("Prefer to talk?"),
    },
    stoerer: { cta: P("Send inquiry"), close: P("Close notice") },
    nav: { cta: P("Send inquiry") },
};

export default { de, en };
